<template>
    <div class="w-full md:w-auto">
        <button
            type="button"
            class="btn btn-md is-ghost"
            @click="$modal.show('subcontractor-transaction-invoice-calculator')"
        >
            {{ totalPercentage }}&nbsp;%
        </button>
        <input
            v-model="percentagesJson"
            type="hidden"
            name="percentages"
        >
        <adaptive-modal
            name="subcontractor-transaction-invoice-calculator"
            primary-button-text="Done"
            primary-button-class="is-primary"
            title="Percentages"
            :show-hide-button="false"
            @save="$modal.hide('subcontractor-transaction-invoice-calculator')"
        >
            <p v-for="percentage in percentages">
                <checkbox-input
                    v-model="percentage.isSelected"
                    class="text-sm mt-sm"
                    :disabled="! isEditable"
                >
                    <span class="font-bold" style="width: 54px;">
                        {{ percentage.percentage }}&nbsp;%
                    </span>&nbsp;{{ percentage.description }}
                </checkbox-input>
            </p>
            <p class="font-bold" style="border-top: 1px solid #d6d6d6; padding: 6px 0 0 36px;">
                <span class="inline-block" style="width: 54px;">
                    {{ totalPercentage }}&nbsp;%
                </span>&nbsp;Total
            </p>
            <table class="my-3xl p-md w-full" style="background-color: antiquewhite; border-spacing: 0;">
                <tr>
                    <td class="text-right whitespace-no-wrap" style="width: 50%;">
                        {{ orderTotal }}
                        &times;
                        {{ totalPercentage }} %
                        =<span class="pl-sm font-bold">{{ orderTotalAvailable }}</span>
                    </td>
                    <td class="pb-sm pl-sm whitespace-no-wrap" style="width: 50%;">
                        available bases total
                    </td>
                </tr>
                <tr>
                    <td class="text-right whitespace-no-wrap">
                        <span class="font-bold">{{ invoiceTotal }}</span>
                    </td>
                    <td class="pb-sm pl-sm whitespace-no-wrap">
                        invoices total
                    </td>
                </tr>
                <tr>
                    <td class="pt-sm text-right font-bold whitespace-no-wrap" style="border-top: 1px solid #b8b8b8;">
                        <span class="font-bold">{{ result }}</span>
                    </td>
                    <td class="pl-sm pt-sm font-bold whitespace-no-wrap" style="border-top: 1px solid #b8b8b8;">
                        balance
                    </td>
                </tr>
            </table>
        </adaptive-modal>
    </div>
</template>

<script>
    export default {
        props: {
            initialPercentages: {
                type: Array,
                required: true,
            },
            invoiceTotal: {
                type: Number,
                required: true,
            },
            isEditable: {
                type: Boolean,
                required: false,
                default: false,
            },
            orderTotal: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                percentages: this.initialPercentages,
            };
        },

        computed: {
            orderTotalAvailable: function () {
                return this.orderTotal * this.totalPercentage / 100;
            },
            percentagesJson: function () {
                return JSON.stringify(this.percentages);
            },
            result: function () {
                return this.orderTotalAvailable - this.invoiceTotal;
            },
            totalPercentage: function () {
                const setInvoiceAmount = this.setInvoiceAmount;

                // eslint-disable-next-line vue/no-async-in-computed-properties
                setTimeout(function () {
                    setInvoiceAmount();
                });

                return this.percentages.filter(p => p.isSelected).reduce((accumulated, percentage) => (accumulated + percentage.percentage), 0);
            },
        },

        methods: {
            setInvoiceAmount: function () {
                const inputElements = document.querySelectorAll('input[name=invoice_amount]');

                inputElements.forEach(inputElement => inputElement.value = this.result);
            },
        },
    };
</script>
